module KendoWidgets
{
	export class DatePickerOptions implements kendo.ui.DatePickerOptions
	{
		dateInput?: boolean;
		width?: string | number;
		isChangingDate?: boolean;
		defaultDay?: DefaultDayEnum;
		css?: string;
		wrapper?: string | JQuery | Element;
		enabled?: boolean;
		visible?: boolean;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		format?: string;
		culture?: string;
		depth?: string;
		footer?: boolean | string | Function;
		max?: Date;
		min?: Date;
		weekNumber?: boolean;
		parseFormats?: any;
		start?: string;
		value?: Date;
		change?(e: kendo.ui.DatePickerChangeEvent): void;
		close?(e: kendo.ui.DatePickerCloseEvent): void;
		open?(e: kendo.ui.DatePickerOpenEvent): void;
	}

	export class DatePicker extends kendo.ui.DatePicker implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.DatePicker; }
		private _firstLoad: boolean;
		private _currentCursorPosition: number;

		constructor(element: Element, options?: KendoWidgets.DatePickerOptions)
		{
			if (options == null)
				options = new KendoWidgets.DatePickerOptions();

			if (options.enabled == null) options.enabled = true;
			if (options.width == null) options.width = 190;
			options.dateInput = false;
			options.isChangingDate = false;
			if (options.culture == null) options.culture = "it-IT";
			if (options.defaultDay == null) options.defaultDay = DefaultDayEnum.First;
			if (options.format == null) options.format = "dd/MM/yyyy";
			if (options.visible == null) options.visible = true;

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			super(element, options);
			let that = this;
			this._currentCursorPosition = 0;

			element.parentElement!.parentElement!.id = element.id + "Parent";
			$(element).parent().parent().addClass("controlParent");

			if (!options.enabled)
				this.enable(false);

			if (!options.visible)
				this.hide();

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.append(label);
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Real date input & Cursor management
			$(element).keydown((e) =>
			{
				let cursorStartPosition = (e.target as HTMLInputElement).selectionStart!;
				if (cursorStartPosition != that._currentCursorPosition)
					that._currentCursorPosition = cursorStartPosition;

				if (e.keyCode == 39) // Arrow right
					that._currentCursorPosition = cursorStartPosition + 1;
				else if (e.keyCode == 37) // Arrow left
					that._currentCursorPosition = cursorStartPosition - 1;
				else if (e.keyCode == 38) // Arrow up
				{
					if (that._currentCursorPosition >= 0 && that._currentCursorPosition <= 2)
						that.value(that.value().addDays(1));
					else if (that._currentCursorPosition >= 3 && that._currentCursorPosition <= 5)
						that.value(that.value().addMonths(1));
					else if (that._currentCursorPosition >= 6)
						that.value(that.value().addYears(1));
				}
				else if (e.keyCode == 40) // Arrow down
				{
					if (that._currentCursorPosition >= 0 && that._currentCursorPosition <= 2)
						that.value(that.value().addDays(-1));
					else if (that._currentCursorPosition >= 3 && that._currentCursorPosition <= 5)
						that.value(that.value().addMonths(-1));
					else if (that._currentCursorPosition >= 6)
						that.value(that.value().addYears(-1));
				}

				options!.isChangingDate = true;
				that.element.parent().css("border", "solid 1px #CCC");

				if (e.keyCode == 39 || e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 40)
				{
					that.updateCursorPosition();
					e.preventDefault();
				}
			});
			$(element).keyup((e) =>
			{
				if (e.keyCode == 13) // Enter
					that.formatDateInput((e.target as HTMLInputElement).value);
			});
			$(element).blur((e) => that.formatDateInput((e.target as HTMLInputElement).value));
			$(element).click((e) => that._currentCursorPosition = (e.target as HTMLInputElement).selectionStart!);
			$(element).focus((e) => that.element.select());
			//#endregion

			//#region Wrapper
			if (options.wrapper != null)
				window.setTimeout(() => this.element.parent().parent().wrap(options!.wrapper!));
			//#endregion
		}

		//#region Date input
		private formatDateInput(inputText: string)
		{
			if (inputText.length == 0 || (this.options as KendoWidgets.DatePickerOptions).isChangingDate || this.options.depth != "month" || this.options.format != "dd/MM/yyyy")
				return;

			//#region Month and Year
			let inputTextArray = inputText.toLowerCase().split(" ");
			if (inputTextArray.length > 1)
			{
				let monthNumber = this.getMonthNumberByName(inputTextArray[0]);
				if (monthNumber != -1)
				{
					if (inputTextArray[1].length == 2 || inputTextArray[1].length == 4)
					{
						let year = parseInt(inputTextArray[1]);
						if (inputTextArray[1].length == 2)
							year = this.getFinalYear(inputTextArray[1]);

						let day = ((this.options as KendoWidgets.DatePickerOptions).defaultDay == DefaultDayEnum.First) ? 1 : Date.getLastDayOfMonthByDate(new Date(new Date().getFullYear(), monthNumber, 1)).getDate();
						this.value(new Date(year, monthNumber, day));
						return;
					}
				}
			}
			//#endregion

			inputText = inputText.replace(/[^\w\s]/gi, '');
			inputText = inputText.replace(/\s/g, '');
			let inputTextNumeric = parseFloat(inputText);

			let day: number | null = 0;
			let month: number | null = 0;
			let year: number | null = 0;
			let dateToReturn: Date | null = null;

			let todayYear = new Date().getFullYear();
			let todayMonth = new Date().getMonth();

			//#region Special
			switch (inputText.toLowerCase())
			{
				case "oggi": this.value(new Date()); return;
				case "ieri": this.value(new Date().addDays(-1)); return;
                case "domani": this.value(new Date().addDays(1)); return;
                case "dopodomani": this.value(new Date().addDays(2)); return;
				case "natale": this.value(new Date(new Date().getFullYear(), 11, 25)); return;
				case "vettore": this.value(new Date(2013, 0, 1)); return;
				case "pumo": { this.value(new Date(1993, 9, 10)); } return;
                case "amore": this.value(new Date(todayYear, 1, 14)); return;
                case "fine anno": this.value(new Date(todayYear, 12, 31)); return;
                case "inizio anno": this.value(new Date(todayYear, 1, 1)); return;
			}
			//#endregion

			//#region Months
			let monthNumber = this.getMonthNumberByName(inputText.toLowerCase());
			if (monthNumber != -1)
			{
				this.value(new Date(todayYear, monthNumber, (((this.options as KendoWidgets.DatePickerOptions).defaultDay == DefaultDayEnum.First) ? 1 : Date.getLastDayOfMonthByDate(new Date(todayYear, monthNumber, 1)).getDate())));
				return;
			}
			//#endregion

			let yearStringToday = new Date().getFullYear().toString();
			let todayYearFull = parseInt(yearStringToday.substr(0, 2) + "00");

			//#region Normal use
			if (inputText.length == 3)
			{
				day = parseFloat(inputText[0]);
				month = parseFloat(inputText[1] + inputText[2]) - 1;
				if (month > 11)
				{
					day = parseFloat(inputText[0] + inputText[1]);
					month = parseFloat(inputText[2]) - 1;
				}
				year = todayYear;
			}
			else if (inputText.length == 4)
			{
				let yearString = inputText[2] + inputText[3];
				let yearNumber = Number(yearString);
				if (yearNumber <= 12 && (Number(inputText[0] + inputText[1]) <= 31))
				{
					day = parseFloat(inputText[0] + inputText[1]);
					month = parseFloat(inputText[2] + inputText[3]) - 1;
					year = todayYear;
				}
				else
				{
					let finalYear = this.getFinalYear(yearString);
					if (inputTextNumeric >= todayYearFull && inputTextNumeric <= new Date().getFullYear())
					{
						day = 1;
						month = 0;
						year = finalYear;

						if ((this.options as KendoWidgets.DatePickerOptions).defaultDay == DefaultDayEnum.Last)
						{
							day = 31;
							month = 11;
						}
					}
					else
					{
						day = parseFloat(inputText[0]);
						month = parseFloat(inputText[1]) - 1;
						year = finalYear;
					}
				}
			}
			else if (inputText.length == 5)
			{
				let yearString = inputText[3] + inputText[4];
				let finalYear = this.getFinalYear(yearString);

				day = parseFloat(inputText[0]);
				month = parseFloat(inputText[1] + inputText[2]) - 1;
				if (month > 11)
				{
					day = parseFloat(inputText[0] + inputText[1]);
					month = parseFloat(inputText[2]) - 1;
				}
				year = finalYear;
			}
			else if (inputText.length == 6)
			{
				let yearString = inputText[4] + inputText[5];
				let finalYear = this.getFinalYear(yearString);

				day = parseFloat(inputText[0] + inputText[1]);
				month = parseFloat(inputText[2] + inputText[3]) - 1;
				if (month > 11)
				{
					day = parseFloat(inputText[0]);
					month = parseFloat(inputText[1]) - 1;
					finalYear = parseFloat(inputText[2] + inputText[3] + inputText[4] + inputText[5]);
				}

				year = finalYear;
			}
			else if (inputText.length == 7)
			{
				let finalYear = parseFloat(inputText[3] + inputText[4] + inputText[5] + inputText[6]);

				day = parseFloat(inputText[0]);
				month = parseFloat(inputText[1] + inputText[2]) - 1;
				if (month > 11)
				{
					day = parseFloat(inputText[0] + inputText[1]);
					month = parseFloat(inputText[2]) - 1;
				}

				year = finalYear;
			}
			else if (inputText.length == 8)
			{
				day = parseFloat(inputText[0] + inputText[1]);
				month = parseFloat(inputText[2] + inputText[3]) - 1;
				year = parseFloat(inputText[4] + inputText[5] + inputText[6] + inputText[7]);
			}
			//#endregion

			dateToReturn = new Date(year, month, day);
			if (dateToReturn != null && this.isValidDate(dateToReturn))
			{
				if (this.value() == null || !Date.equals(this.value(), dateToReturn))
					this.value(dateToReturn);
			}
			else
				this.element.parent().css("border", "solid 1px red");

			(this.options as KendoWidgets.DatePickerOptions).isChangingDate = false;
		}

		private getFinalYear(yearString: string): number
		{
			let yearStringToday = new Date().getFullYear().toString();
			let todayYearFull = parseInt(yearStringToday.substr(0, 2) + "00");

			let inputYear = parseInt(yearString.substr(0, 2));
			let yearFinalString = "";
			if (inputYear <= (new Date().getFullYear() - todayYearFull))
				yearFinalString = "20" + yearString.substr(0, 2);
			else
				yearFinalString = "19" + yearString.substr(0, 2);

			return parseFloat(yearFinalString);
		}

		private isValidDate(date: Date)
		{
			return date instanceof Date && !isNaN(date.getTime());
		}
		//#endregion

		clear(date?: Date, triggerChange = true)
		{
			if (date != null)
				this.value(date, triggerChange);
			else
				this.value("", triggerChange);
		}

		isEmpty()
		{
			return (this.value() == null);
		}

		focus()
		{
			this.element.focus();
		}

		width(width?: number | string)
		{
			if (width != null)
				this.element.parent().parent().width(width);

			return this.element.parent().parent().width();
		}

		value(date?: Date | string | null, triggerChange = true): Date
		{
			if (date != null)
			{
				if (typeof (date) == "string")
				{
					date = Date.fixDateString(date);
					super.value(date);
				}
				else
					super.value(date);

				if (triggerChange)
					this.trigger("change");
			}
			return super.value();
		}

		disable()
		{
			this.enable(false);
		}

		//#region Visibility
		visible(state?: boolean)
		{
			if (state != null)
			{
				if (state) this.element.parent().parent().show();
				else this.element.parent().parent().hide();
			}
			return this.element.parent().parent().is(":visible");
		}

		show()
		{
			this.visible(true);
		}

		hide()
		{
			this.visible(false);
		}
		//#endregion

		today()
		{
			this.value(Date.today());
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().prependTo(element);
		}

		private getMonthNumberByName(monthName: string)
		{
			switch (monthName.toLowerCase())
			{
				case "gennaio": return MonthEnum.January;
				case "febbraio": return MonthEnum.February;
				case "marzo": return MonthEnum.March;
				case "aprile": return MonthEnum.April;
				case "maggio": return MonthEnum.May;
				case "giugno": return MonthEnum.June;
				case "luglio": return MonthEnum.July;
				case "agosto": return MonthEnum.August;
				case "settembre": return MonthEnum.September;
				case "ottobre": return MonthEnum.October;
				case "novembre": return MonthEnum.November;
				case "dicembre": return MonthEnum.December;
				default:
					return -1;
			}
		}

		private updateCursorPosition()
		{
			let elem = this.element[0] as any;
			if (elem.createTextRange)
			{
				var range = elem.createTextRange();
				range.move('character', this._currentCursorPosition);
				range.select();
			}
			else
			{
				if (elem.selectionStart >= 0)
				{
					elem.focus();
					elem.setSelectionRange(this._currentCursorPosition, this._currentCursorPosition);
				}
				else
					elem.focus();
			}
		}
	}

	DatePicker.fn = DatePicker.prototype;
	DatePicker.fn.options = $.extend(true, {}, kendo.ui.DatePicker.fn.options);
	DatePicker.fn.options.name = "DatePicker";
	kendo.ui.plugin(DatePicker);
}

interface JQuery
{
	kendoDatePicker(options?: KendoWidgets.DatePickerOptions): JQuery;
}

enum DefaultDayEnum
{
	First,
	Last
}

enum MonthEnum
{
	January,
	February,
	March,
	April,
	May,
	June,
	July,
	August,
	September,
	October,
	November,
	December
}